module.exports = __webpack_public_path__ + "static/media/Loading.c30c7e1c.png";